(function () {
  function parseSrcs(button) {
    var srcs = [];
    for (var i = 1; i <= 3; i++) {
      var src = (button.getAttribute('data-jojo-voice-src-' + i) || '').trim();
      if (src) srcs.push(src);
    }
    return srcs;
  }

  function nextSrc(items, index) {
    if (!items.length) return { src: '', nextIndex: 0 };
    var i = index % items.length;
    if (i < 0) i = 0;
    return { src: items[i], nextIndex: (i + 1) % items.length };
  }

  function initJojoListingVoice(root) {
    if (!root || root.dataset.jojoVoiceReady === 'true') return;
    root.dataset.jojoVoiceReady = 'true';

    var audio = new Audio();
    audio.preload = 'none';
    var lastFocus = null;
    var openModalEl = null;
    var nextIndexByKey = {};

    function stopAudio() {
      try {
        audio.pause();
        audio.removeAttribute('src');
        audio.load();
      } catch (e) {}
    }

    function playNext(button) {
      var srcs = parseSrcs(button);
      var key = button.getAttribute('data-jojo-voice-play') || '';
      var picked = nextSrc(srcs, nextIndexByKey[key] || 0);
      if (!picked.src) return;
      nextIndexByKey[key] = picked.nextIndex;
      stopAudio();
      audio.src = picked.src;
      var playPromise = audio.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {});
      }
    }

    function lockScroll(lock) {
      document.documentElement.classList.toggle('jojo-voice-modal-open', lock);
    }

    function closeModal() {
      if (!openModalEl) return;
      openModalEl.hidden = true;
      openModalEl.setAttribute('aria-hidden', 'true');
      openModalEl.classList.remove('is-open');
      openModalEl = null;
      lockScroll(false);
      if (lastFocus && typeof lastFocus.focus === 'function') {
        lastFocus.focus();
      }
      lastFocus = null;
    }

    function openModal(name, trigger) {
      var modal = root.querySelector('[data-jojo-voice-modal="' + name + '"]');
      if (!modal) return;
      if (openModalEl && openModalEl !== modal) closeModal();
      lastFocus = trigger || document.activeElement;
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      modal.classList.add('is-open');
      openModalEl = modal;
      lockScroll(true);
      var closeBtn = modal.querySelector('[data-jojo-voice-close]');
      if (closeBtn) closeBtn.focus();
    }

    root.addEventListener('click', function (event) {
      var openBtn = event.target.closest('[data-jojo-voice-open]');
      if (openBtn && root.contains(openBtn)) {
        event.preventDefault();
        openModal(openBtn.getAttribute('data-jojo-voice-open'), openBtn);
        return;
      }

      var playBtn = event.target.closest('[data-jojo-voice-play]');
      if (playBtn && root.contains(playBtn)) {
        event.preventDefault();
        playNext(playBtn);
        return;
      }

      var closeEl = event.target.closest('[data-jojo-voice-close]');
      if (closeEl && root.contains(closeEl)) {
        event.preventDefault();
        closeModal();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && openModalEl) {
        closeModal();
      }
    });

    document.addEventListener('shopify:section:unload', function (event) {
      if (event.target.contains(root)) {
        stopAudio();
        closeModal();
      }
    });
  }

  function initAll() {
    document.querySelectorAll('[data-jojo-listing-voice]').forEach(initJojoListingVoice);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-jojo-listing-voice]');
    if (root) {
      root.dataset.jojoVoiceReady = 'false';
      initJojoListingVoice(root);
    }
  });
})();
